import { useQuery, UseQueryOptions } from 'react-query';
import { StorageInfo, QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { useRecordings } from '@24i/nxg-sdk-smartott-shared/src/context/Recordings';

export const useStorageInfo = (options?: UseQueryOptions<StorageInfo>) => {
    const { fetchStorageInfo } = useRecordings();

    return useQuery<StorageInfo>(QUERY_KEYS.storageInfo, fetchStorageInfo, options);
};
